export default "__VITE_PUBLIC_ASSET__bd7e4d22__"